import styled from '@emotion/styled'

const Header = () => {
	return (
		<HeaderWrapper>
			<Title>브랜드 정보 관리</Title>
			<SaveButton type="submit">저장</SaveButton>
		</HeaderWrapper>
	)
}

const HeaderWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`

const Title = styled.h1`
	color: #000;
	font-family: Pretendard;
	font-size: 3rem;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.2px;
`

const SaveButton = styled.button`
	border: none;
	background-color: #ffcf19;
	padding: 1.35rem 2.5rem;
	border-radius: 1.1rem;
	color: #121212;
	font-family: Pretendard;
	font-size: 1.6rem;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.2px;
`

export default Header
